import { LoadingOutlined, WarningOutlined } from "@/icons"

import type { StatusIconProps } from "."

export const Icon = (props: StatusIconProps) => {
  if (props.status === "pending") return <LoadingOutlined />
  if (props.status === "failed") return <WarningOutlined />

  return null
}
